import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  grid: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
});
